import Phaser from 'phaser';

export const MODELS = {
  FRANKIE: 'frankie',
  MUMMY: 'mummy',
  SKELETON: 'skeleton',
  ZOMBIE: 'zombie',
};

class Hanger extends Phaser.GameObjects.Sprite {
  constructor(scene, x, y) {
    super(scene, x, y, 'hanger');

    this.setOrigin(0.5, 0);
    this.scene.add.existing(this);
  }
}

class Costume extends Phaser.GameObjects.Sprite {
  constructor(scene, x, y, model) {
    super(scene, x, y, model);

    this.setOrigin(0.5, 0);
    this.scene.add.existing(this);
  }
}

export default class CostumeSet extends Phaser.GameObjects.Container {
  constructor(scene, x, y, model) {
    super(scene, x, y);

    this.MODEL = model;

    this.setSize(240, 300);
    this.setScale(0.7);
    this.setAngle(4);

    this._hanger = new Hanger(scene, 0, 0);
    this._costume = new Costume(scene, 0, 160, model);
    this.add([this._hanger, this._costume]);
    
    scene.add.existing(this);

    this.scene.tweens.addCounter({
      // targets: this,
      duration: 5000,
      ease: Phaser.Math.Easing.Cubic.InOut,
      yoyo: true,
      delay: Math.random() * 8000,
      repeat: -1,
      from: 4,
      to: -4,
      onUpdate: (tween) => {
        this.setAngle(tween.getValue());
      },
    });
  }

  fade() {
    this.scene.tweens.add({
      targets: this,
      duration: 1000,
      alpha: 0.2,
      ease: Phaser.Math.Easing.Quadratic.Out,
    });
  }
}

export function preload() {
  this.load.image(`hanger`, `ornaments/hanger.png`);
  this.load.image(MODELS.FRANKIE, `characters/frankie.png`);
  this.load.image(MODELS.MUMMY, `characters/mummy.png`);
  this.load.image(MODELS.SKELETON, `characters/skeleton.png`);
  this.load.image(MODELS.ZOMBIE, `characters/zombie.png`);
}
